/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
// eslint-disable-next-line import/no-extraneous-dependencies
import { CheckCircle2 } from 'lucide-react';
import ConfirmDialog from '../ConfirmDialog';

function ResolveModal({
  closeModal,
  handleResolve,
  isAll,
}) {
  const handleClick = () => {
    handleResolve();
    closeModal();
  };

  return (
    <ConfirmDialog
      tone="success"
      icon={<CheckCircle2 size={24} />}
      title={isAll ? 'Are you sure you want to resolve all issues?' : 'Are you sure you want to resolve this issue?'}
      description={isAll
        ? 'This action cannot be undone and will mark all issues as resolved. Please confirm your decision below.'
        : 'This action cannot be undone. Please confirm your decision below.'}
      confirmLabel={isAll ? 'Resolve All' : 'Resolve'}
      cancelLabel="Cancel"
      onConfirm={handleClick}
      onCancel={closeModal}
    />
  );
}

ResolveModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  handleResolve: PropTypes.func.isRequired,
  isAll: PropTypes.bool.isRequired,
};

export default ResolveModal;
